import { Box, Typography } from "@mui/material";
import type { PartnerActivityEntry } from "../../model";
import { PartnerActivityTile } from "./PartnerActivityTile";

interface PartnerActivityTilesProps {
  entries: PartnerActivityEntry[];
}

/**
 * Mobile alternative to `PartnerActivityTable` — one `PartnerActivityTile`
 * per entry, in whatever order/sort the entries already arrive in.
 * `PartnerDeepDive` swaps to this automatically below the `sm` breakpoint,
 * matching `MetricsDashboardPage`'s `PartnerMetricsTiles` precedent (CPD-67)
 * — no user-facing table/tile toggle.
 */
export function PartnerActivityTiles({ entries }: PartnerActivityTilesProps) {
  if (entries.length === 0) {
    return (
      <Typography variant="body2" color="text.secondary" sx={{ py: 2, textAlign: "center" }}>
        No activity matches the current filters.
      </Typography>
    );
  }

  return (
    <Box sx={{ display: "grid", gap: 1.5, p: 1.5 }}>
      {entries.map((entry, index) => (
        // Activity entries have no stable id in the model; time+index is
        // stable within one render of this (already sorted) array — same
        // key strategy PartnerActivityTable uses for its rows.
        <PartnerActivityTile key={`${entry.time}-${index}`} entry={entry} />
      ))}
    </Box>
  );
}
